import { Badge } from "react-bootstrap";

export const getCountBadge = (count: number | null) => {
  if (!count) {
    return (
      <Badge className="m-1" bg="danger">
        Stan magazynowy: brak
      </Badge>
    );
  }

  if (count < 5) {
    return (
      <Badge className="m-1" bg="warning">
        Stan magazynowy: {count}
      </Badge>
    );
  }

  return (
    <Badge className="m-1" bg="success">
      Stan magazynowy: {count}
    </Badge>
  );
};
